import { render, staticRenderFns } from "./University.vue?vue&type=template&id=3f059a6f&scoped=true&"
import script from "./University.vue?vue&type=script&lang=js&"
export * from "./University.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f059a6f",
  null
  
)

export default component.exports